import React from "react";

interface FormattedTextProps {
  text: string;
  sender: string;
}

const FormattedText: React.FC<FormattedTextProps> = ({ text, sender }) => {
  return (
    <div>
      {text.split("\n").map((line, lineIndex) => (
        <p key={lineIndex}>
          {lineIndex === 0 && <strong>{sender}: </strong>}
          {line
            .split(/(###\s*[^\n]+)/)
            .map((part, idx) =>
              part.startsWith("###") ? (
                <strong key={idx}>{part.replace("###", "").trim()}</strong>
              ) : (
                part
                  .split(/(\*\*[^*]+\*\*)/)
                  .map((subPart, subIdx) =>
                    subPart.startsWith("**") && subPart.endsWith("**") ? (
                      <strong key={subIdx}>{subPart.slice(2, -2)}</strong>
                    ) : (
                      subPart
                    )
                  )
              )
            )}
        </p>
      ))}
    </div>
  );
};

export default FormattedText;
